import Image from "next/image";
import React from "react";
import styles from "./donorPath.module.scss";
import plural from "plural-ru";
import { Props } from "./IDonorPath";
import { BLOOD_CLASES } from "../../../entities";
import { inject, observer } from "mobx-react";
import Button from "../ui/button/Button";
import infoImg from "../../../new-images/profile/info.svg";
import bloodBorderImg from "../../../new-images/profile/blood-border.svg";
import certificateImg from "../../../new-images/profile/certificate.svg";
import lockImg from "../../../new-images/profile/lock.svg";

const DonorPath: React.FC<Props> = ({ donorPathLoader, honor, authStore }) => {
  const { current_blood, current_plasma, current_sum, state, message } = honor;
  // Делю первый груг на 40 равных частей
  const firstCircle = Array.from({ length: 40 }, (_, i) => ({
    color: "#F8F8F8",
    deg: `${i * 9}deg ${i * 9 + 9}deg`,
  }));

  // Делю круг на 60 равных частей
  const secondCircle = Array.from({ length: 60 }, (_, i) => ({
    color: "#F8F8F8",
    deg: `${i * 6}deg ${i * 6 + 6}deg`,
  }));

  const firstCircleColors = firstCircle.map((item, index) => {
    if (index >= 0 && index < current_blood) {
      return { ...item, color: "#F63E3E" };
    } else if (
      current_blood >= 25
        ? index >= current_blood && index <= current_sum - 1
        : index >= 25 && index <= 24 + current_plasma
    ) {
      return { ...item, color: "#F7C41C" };
    } else {
      return item;
    }
  });

  const secondCircleColors = secondCircle.map((item, index) => {
    if (index >= 0 && index < current_blood) {
      return { ...item, color: "#F63E3E" };
    } else if (index >= 0 && index >= current_blood && index < current_sum) {
      return { ...item, color: "#F7C41C" };
    } else {
      return item;
    }
  });

  const handleSubmitCertificate = () => {
    authStore
      .update({ donor_certificate: true })
      .then((res) => console.log(res))
      .catch((err) => console.log(err));
  };

  const isRectangle = (first_component: number, second_component: number) => {
    return (
      (first_component > 0 && second_component > 0) ||
      (first_component === 0 && second_component === 0)
    );
  };

  if (message === 'no_content') return null;

  return authStore?.user?.donor_certificate ? (
    <div className={styles.DonorPath}>
      <div className={styles.Content}>
        <h5
          className={`${styles.ContentTitle} ${styles.ContentTitleCertificate}`}
        >
          Почетный донор России
        </h5>
        <Image
          className={styles.ContentCertificateImg}
          src={certificateImg}
          alt="certificate"
          width={150}
          height={160}
        />
        <p className={styles.ContentCertificateSubtitle}>
          Благодарим за вклад в спасение жизней
        </p>
      </div>
    </div>
  ) : state === "in_progress" ? (
    <div
      className={`${styles.DonorPath} ${
        isRectangle(current_blood, current_plasma) && (current_blood < 25 && current_plasma < 35) && styles.DonorPathWithPlasma
      }`}
    >
      <div className={styles.Content}>
        <h5
          className={`${styles.ContentTitle} ${
            isRectangle(current_blood, current_plasma) &&
            styles.ContentTitleCenter
          }`}
        >
          Путь к званию Почётного донора России
        </h5>

        <div className={styles.ContentBlocks}>
          {(isRectangle(current_blood, current_plasma) ||
            (current_blood > 0 && current_plasma === 0)) && (current_plasma < 35) && (
            <div className={styles.ContentBlocksBlock}>
              <InfoComponent roundName="first" />
              <div className={styles.ContentBlocksBlockRound}>
                <div
                  className={styles.Border}
                  style={{
                    background: `conic-gradient(${firstCircleColors.map(
                      (item) => `${item.color} ${item.deg}`
                    )})`,
                  }}
                >
                  <div className={styles.Circle}></div>
                </div>
                <RoundCountentComponent honor={honor} round_name="first" />
              </div>
              {!(current_blood > 25 && current_plasma === 0) && (
                <div className={styles.ContentBlocksBlockBorder}>
                  <Image src={bloodBorderImg} alt="" width={25} height={25} />
                </div>
              )}
              <div className={styles.ContentBlocksBlockText}>
                <p className={styles.ContentBlocksBlockTextSubtitle}>
                  {plural(
                    40 - honor?.current_sum || 0,
                    "Осталась",
                    "Осталось",
                    "Осталось"
                  )}{" "}
                  <span className={styles.ContentBlocksBlockTextSubtitleCount}>
                    {(current_plasma < 15
                      ? 40 - honor?.current_sum
                      : 40 - (honor?.current_blood + 15)) || 0}
                  </span>{" "}
                  из{" "}
                  <span className={styles.ContentBlocksBlockTextSubtitleCount}>
                    40
                  </span>{" "}
                  донаций
                </p>
                {current_blood < 25 && (
                  <p className={styles.ContentBlocksBlockTextFooter}>
                    Из них минимум{" "}
                    <span className={styles.ContentBlocksBlockTextFooterCount}>
                      {25 - honor?.current_blood || 0}
                    </span>{" "}
                    {plural(
                      25 - honor?.current_blood,
                      "донация",
                      "донации",
                      "донаций"
                    )}{" "}
                    цельной крови/клеточных компонентов
                  </p>
                )}
              </div>
            </div>
          )}

          {
            isRectangle(current_blood, current_plasma) && (current_blood < 25 && current_plasma < 35) && <div className={styles.ContentBlocksBlock}>или</div>
          }

          {(isRectangle(current_plasma, current_blood) ||
            (current_plasma > 0 && current_blood === 0)) && current_blood < 25 && (
            <div className={styles.ContentBlocksBlock}>
              <InfoComponent roundName="second" />
              <div className={styles.ContentBlocksBlockRound}>
                <div
                  className={styles.Border}
                  style={{
                    background: `conic-gradient(${secondCircleColors.map(
                      (item) => `${item.color} ${item.deg}`
                    )})`,
                  }}
                >
                  <div className={styles.Circle}></div>
                </div>
                <RoundCountentComponent honor={honor} />
              </div>
              <div className={styles.ContentBlocksBlockText}>
                <p className={styles.ContentBlocksBlockTextSubtitle}>
                  {plural(
                    60 - honor?.current_sum || 0,
                    "Осталась",
                    "Осталось",
                    "Осталось"
                  )}{" "}
                  <span className={styles.ContentBlocksBlockTextSubtitleCount}>
                    {60 - honor?.current_sum || 0}
                  </span>{" "}
                  из{" "}
                  <span className={styles.ContentBlocksBlockTextSubtitleCount}>
                    60
                  </span>{" "}
                  донаций
                </p>
                <p className={styles.ContentBlocksBlockTextFooter}>
                  Если донаций цельной крови/клеточных компонентов меньше{" "}
                  <span className={styles.ContentBlocksBlockTextFooterCount}>
                    25
                  </span>
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  ) : state === "done" ? (
    <div className={styles.DonorPath}>
      <div className={styles.Content}>
        <h5 className={styles.ContentTitle}>
          Путь к званию Почётного донора России
        </h5>
        <div className={styles.ContentRectangle}>
          <InfoComponent state={state} roundName="green" />
          <RoundCountentComponent honor={honor} round_name="green" />
        </div>
        <p className={styles.ContentSubtitle}>
          Вы набрали достаточное количество донаций для получения звания. Вы уже
          получили удостоверение Почётного донора России?
        </p>
        <div className={styles.ContentButtons}>
          <Button onClick={handleSubmitCertificate} color="green">
            <span>Да</span>
          </Button>
          <a
            className={styles.ContentButtonsLink}
            href="https://www.gosuslugi.ru/help/faq/donor/102288"
            target="_blank"
          >
            <Button>
              <span>Нет</span>
            </Button>
          </a>
        </div>
      </div>
    </div>
  ) : (
    <div className={styles.DonorPath}>
      <div className={!donorPathLoader ? styles.Content : styles.Show}></div>
    </div>
  );
};

interface IInfoComponentProps {
  state?: string;
  roundName: string;
}
const InfoComponent: React.FC<IInfoComponentProps> = ({ state, roundName }) => {
  return (
    <div
      className={`${styles.ContentBlocksBlockInfo} ${
        state === "done" && styles.ContentRectangleGreen
      }`}
    >
      <Image
        className={styles.ContentBlocksBlockInfoImg}
        src={infoImg}
        alt="info"
        width={16}
        height={16}
      />
      <div
        className={`${styles.ContentBlocksBlockInfoPrompt} ${
          state === "done" && styles.ContentRectangleGreenPrompt
        }`}
      >
        <div
          className={`${styles.ContentBlocksBlockInfoPromptBlock} ${styles.Prompt}`}
        >
          {(roundName === "first" || roundName === "second") && (
            <>
              <h6 className={styles.PromptTitle}>
                {roundName === "first"
                  ? "Это круговая диаграмма на 40 донаций: здесь учитываются не более 15 донаций плазмы."
                  : "Это круговая диаграмма на 60 донаций: здесь учитываются любые донации (кровь/компоненты и плазма)."}
              </h6>
              <p className={styles.PromptText}>Подробнее:</p>
            </>
          )}
          <p className={styles.PromptText}>
            Как стать Почётным донором России?
          </p>
          <ul className={styles.PromptList}>
            <li
              className={`${styles.PromptListLi} ${
                roundName === "first" && styles.PromptListLiBold
              }`}
            >
              Сдать кровь/компоненты (кроме плазмы) 40 и более раз
            </li>
            <span className={styles.PromptListSpan}>или</span>
            <li
              className={`${styles.PromptListLi} ${
                roundName === "first" && styles.PromptListLiBold
              }`}
            >
              Сдать кровь/компоненты 25 и более раз + плазму, чтобы в сумме
              получилось 40 донаций
            </li>
            <span className={styles.PromptListSpan}>или</span>
            <li
              className={`${styles.PromptListLi} ${
                roundName === "second" && styles.PromptListLiBold
              }`}
            >
              Сдать кровь/компоненты менее 25 раз + плазму, чтобы в сумме
              получилось 60 донаций
            </li>
            <span className={styles.PromptListSpan}>или</span>
            <li
              className={`${styles.PromptListLi} ${
                roundName === "second" && styles.PromptListLiBold
              }`}
            >
              Сдать плазму 60 раз
            </li>
          </ul>
          <p className={styles.PromptText}>
            Сдача клеточных компонентов крови (тромбоциты, эритроциты,
            гранулоциты) приравнивается к донации цельной крови.
          </p>
          <p className={styles.PromptText}>
            В зачёт идут только{" "}
            <span className={styles.PromptTextSpan}>безвозмездные</span>{" "}
            донации.
          </p>
        </div>
      </div>
    </div>
  );
};

interface IRoundCountentComponent {
  honor: {
    current_blood?: number;
    current_plasma?: number;
  };
  round_name?: string;
}
const RoundCountentComponent: React.FC<IRoundCountentComponent> = ({
  honor,
  round_name,
}) => {
  const { current_blood, current_plasma } = honor;
  return (
    <div className={styles.ContentBlocksBlockRoundContent}>
      <span className={styles.ContentBlocksBlockRoundContentSpan}>
        {round_name === "green" ? "Вы сдали:" : "Учитываются:"}
      </span>
      <div className={styles.ContentBlocksBlockRoundContentItems}>
        {round_name === "first"
          ? (current_plasma > 0 ||
              (current_plasma === 0 && current_blood === 0)) && (
              <div className={styles.ContentBlocksBlockRoundContentItemsBlood}>
                {current_plasma >= 15 && (
                  <Image src={lockImg} alt="lock" width={8.12} height={13} />
                )}
                <span
                  className={`${
                    styles.ContentBlocksBlockRoundContentItemsBloodNumber
                  } ${
                    current_plasma >= 15 &&
                    styles.ContentBlocksBlockRoundContentItemsBloodNumber_disabled
                  }`}
                >
                  {current_plasma >= 15 ? 15 : current_plasma}
                </span>
                <Image
                  className={styles.ContentBlocksBlockRoundContentItemsBloodImg}
                  src={BLOOD_CLASES.plasma.icon}
                  alt="plasma"
                  width={15}
                  height={15}
                />
              </div>
            )
          : (current_plasma > 0 ||
              (current_plasma === 0 && current_blood === 0)) && (
              <div className={styles.ContentBlocksBlockRoundContentItemsBlood}>
                <span
                  className={
                    styles.ContentBlocksBlockRoundContentItemsBloodNumber
                  }
                >
                  {current_plasma}
                </span>
                <Image
                  className={styles.ContentBlocksBlockRoundContentItemsBloodImg}
                  src={BLOOD_CLASES.plasma.icon}
                  alt="plasma"
                  width={15}
                  height={15}
                />
              </div>
            )}
        {(current_blood > 0 ||
          (current_plasma === 0 && current_blood === 0)) && (
          <div className={styles.ContentBlocksBlockRoundContentItemsBlood}>
            <span
              className={styles.ContentBlocksBlockRoundContentItemsBloodNumber}
            >
              {current_blood}
            </span>
            <Image
              className={styles.ContentBlocksBlockRoundContentItemsBloodImg}
              src={"/static/images/icons/bloodAndComponents.svg"}
              alt="blood"
              width={15}
              height={15}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default inject("authStore")(observer(DonorPath));
